<template>
  <div class="zgq-container">
    <Block
      v-for="(item, index) in itemList"
      :key="index"
      :block="item"
    ></Block>
    <Scroll :scrollFlag="scrollFlag" :isEnd="isEnd" />
  </div>
</template>

<script>
import Block from "../components/Block.vue";
import mixin from "@/mixins/scrollPager";
import Scroll from "@/components/paging/scroll";
export default {
  components: {
    Block,
    Scroll
  },
  mixins: [mixin],
  data() {
    return {
      params: {
        status: 2,
        pageNo: 1,
        pageSize: 10,
        userList: [this.$route.query.id],
      },
    };
  },
  created() {
    this.getList(this.params);
  },
  methods: {
    async getList(data) {
      this.scrollFlag = true;
      const resp = await this.$apis.zgqServe.getMyPage(data);
      console.log(resp);
      this.total = +resp.page.total;
      this.itemList.push(...resp.page.list);
      this.scrollFlag = false;
      this.isEnd = this.pageNum >= this.total / 10;
    },
  },
};
</script>

<style lang="scss" scoped>
.zgq-container {
  background-color: #fff;
  min-height: 700px;
  padding-bottom: 19px;
}
</style>
